import React, { useState } from 'react';
import Page, { PageHeader, PageTitle, Container } from 'components/Page';
import { Formik, Field, Form } from 'formik';
import BaseAlert from 'packages/ui/Alert';
import Button from 'packages/ui/Button';
import { api, history } from 'app';
import { FormControl, FormGroup, Label } from 'components/form/Formik';
import SwitchInput from 'packages/ui/SwitchInput';
import styled from 'styled-components';

const SwitchWrapper = styled('div')`
  padding: 16px 0;
`;
function CreateBalePost({ match: { params } }) {
  const [submittingMsg, setSubmittingMsg] = useState('');
  const [initialValues, setInitialValues] = useState({
    text: '',
    photo: '',
    event_id: '',
    buttons: {
      signUp_url: '',
      discount_code: '',
      other_organization_events: false,
      custom: {
        text: '',
        url: ''
      }
    }
  });

  return (
    <Page>
      <PageHeader>
        <PageTitle>ایجاد پست در بله</PageTitle>
      </PageHeader>
      <Container>
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          onSubmit={(values, actions) => {
            actions.setSubmitting(true);
            api
              .post(`/bot/bale/send-event-to-channel`, { ...values })
              .then(() => {
                setSubmittingMsg('پست بله با موفقیت ایجاد شد.');
                setTimeout(() => {
                  history.push('/bale-posts/new');
                }, 2000);
              })
              .catch(err => {
                const firstError =
                  err && err.errors ? Object.values(err.errors)[0][0] : 'خطا در ارسال درخواست';
                setSubmittingMsg(firstError);
              })
              .finally(() => actions.setSubmitting(false));
          }}
        >
          {({ values, setFieldValue }) => {
            return (
              <Form>
                <FormGroup>
                  <FormControl>
                    <Label htmlFor="text">متن</Label>
                    <Field id="text" name="text" as="textarea" />
                  </FormControl>
                  <FormControl>
                    <Label htmlFor="photo">لینک عکس</Label>
                    <Field id="photo" name="photo" type="text" />
                  </FormControl>
                </FormGroup>

                <FormGroup>
                  <FormControl>
                    <Label htmlFor="event_id">شناسه رویداد</Label>
                    <Field id="event_id" name="event_id" placeholder="1234" type="text" />
                  </FormControl>
                </FormGroup>

                <FormGroup>
                  <FormControl>
                    <Label htmlFor="signUp_url">آدرس ثبت‌نام</Label>
                    <Field id="signUp_url" name="buttons.signUp_url" type="text" />
                  </FormControl>
                  <FormControl>
                    <Label htmlFor="discount_code">کد تخفیف</Label>
                    <Field id="discount_code" name="buttons.discount_code" type="text" />
                  </FormControl>
                  <FormControl>
                    <Label htmlFor="other_organization_events">رویداد بقیه برگزارکننده‌ها</Label>
                    <SwitchWrapper>
                      <SwitchInput
                        id="other_organizations_events"
                        checked={values.buttons.other_organization_events}
                        onChange={e => {
                          setFieldValue('buttons.other_organization_events', e.target.checked);
                        }}
                      />
                    </SwitchWrapper>
                  </FormControl>
                </FormGroup>

                <FormGroup>
                  <FormControl>
                    <h4>دکمه شخصی</h4>
                  </FormControl>
                  <FormControl />

                  <FormControl>
                    <Label htmlFor="text">متن</Label>
                    <Field id="text" name="buttons.custom.text" type="text" />
                  </FormControl>
                  <FormControl>
                    <Label htmlFor="custom_url">لینک</Label>
                    <Field id="custom_url" name="buttons.custom.url" type="text" />
                  </FormControl>
                </FormGroup>

                <Button type="submit">ذخیره</Button>

                {submittingMsg && (
                  <BaseAlert mood="info" title={submittingMsg}>
                    {submittingMsg}
                  </BaseAlert>
                )}
              </Form>
            );
          }}
        </Formik>
      </Container>
    </Page>
  );
}

export default CreateBalePost;
